// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fx-a";
export var fulfillmentFormRail = "_fx-9";
export var headerTitleRow = "_fx-c";
export var orderDetailsWrapper = "_fx-7";
export var orderLinkTrigger = "_fx-2";
export var paymentInformationGrid = "_fx-h";
export var paymentSummaryColumn = "_fx-i";
export var shipmentContainer = "_fx-b";
export var shipmentDetailsMainPane = "_fx-8";
export var shipmentNavigationCard = "_fx-5";
export var shipmentNavigationRail = "_fx-3";
export var shipmentNavigationRailHeader = "_fx-4";
export var shipmentSummaryFact = "_fx-e";
export var shipmentSummaryGrid = "_fx-d";
export var shipmentSummaryMetadataRow = "_fx-f";
export var shipmentSummaryTags = "_fx-g";
export var shipmentWorkspace = "_fx-0";
export var shipmentWorkspaceContent = "_fx-6";
export var shipmentWorkspaceHeader = "_fx-1";